// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#car-activePivot {
  border-bottom: 3px solid orange;
}
.car-selectPivots {
  cursor: pointer;
}
.car-helpPivots {
  display: flex;
  justify-content: space-evenly;
  font-family: "Amatic SC";
  font-size: 2vw;
  font-weight: 900;
}
.carrier-transButtons-help {
  display: grid;
  column-gap: 2vh;
  justify-self: center;
  grid-template-columns: repeat(2, 3.5vw);
  padding: 1vh;
}
.carrier-persButtons-help-animal {
  display: grid;
  justify-self: center;
  grid-template-columns: repeat(3, 3.5vw);
}
.carrier-persButtons-help-family {
  display: grid;
  justify-self: center;
  grid-template-columns: repeat(4, 3.5vw);
}
.car-closeButton {
  position: absolute;
  top: 1%;
  left: 1%;
  height: 2.5vw;
  cursor: pointer;
}
.car-iconhelp {
  height: 2vw;
  place-content: center;
}
.carrier-icon-help {
  height: 2.2vw;
  width: 100%;
}
.carrier-icons-help {
  height: 2.5vw;
  width: 100%;
}
.next-help {
  filter: brightness(0.8);
}
#car-modesCards {
  direction: rtl;
  overflow: auto;
  height: 95%;
}
.car-helpPanel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 31vw;
  padding: 1.5%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.2),
    0 6px 20px rgba(0, 0, 0, 0.19);
  z-index: 2;
}
.car-helpCard {
  position: relative;
  direction: ltr;
  padding: 1vw;
  margin: 1.25vw;
  width: auto;
  border: solid 1px #1a6a7c;
  border-radius: 10px;
  background: #ffffff;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
  font-size: 1.5vw;
}
.car-cardCaption {
  font-family: "Amatic SC";
  font-size: 2vw;
}
.car-auxButtonshelp {
  display: grid;
  width: 50%;
  grid-template-columns: repeat(3, auto);
  gap: 0.5vw;
  justify-self: center;
}
::-webkit-scrollbar-thumb {
  background-image: linear-gradient(90deg, #cecece, #cecece);
}

::-webkit-scrollbar {
  width: 0.5vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Carrier/styles/Carhelppanel.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,yDAAgE;EAChE;;kCAEgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,sCAAsC;EACtC,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,0DAA0D;AAC5D;;AAEA;EACE,YAAY;AACd","sourcesContent":["#car-activePivot {\n  border-bottom: 3px solid orange;\n}\n.car-selectPivots {\n  cursor: pointer;\n}\n.car-helpPivots {\n  display: flex;\n  justify-content: space-evenly;\n  font-family: \"Amatic SC\";\n  font-size: 2vw;\n  font-weight: 900;\n}\n.carrier-transButtons-help {\n  display: grid;\n  column-gap: 2vh;\n  justify-self: center;\n  grid-template-columns: repeat(2, 3.5vw);\n  padding: 1vh;\n}\n.carrier-persButtons-help-animal {\n  display: grid;\n  justify-self: center;\n  grid-template-columns: repeat(3, 3.5vw);\n}\n.carrier-persButtons-help-family {\n  display: grid;\n  justify-self: center;\n  grid-template-columns: repeat(4, 3.5vw);\n}\n.car-closeButton {\n  position: absolute;\n  top: 1%;\n  left: 1%;\n  height: 2.5vw;\n  cursor: pointer;\n}\n.car-iconhelp {\n  height: 2vw;\n  place-content: center;\n}\n.carrier-icon-help {\n  height: 2.2vw;\n  width: 100%;\n}\n.carrier-icons-help {\n  height: 2.5vw;\n  width: 100%;\n}\n.next-help {\n  filter: brightness(0.8);\n}\n#car-modesCards {\n  direction: rtl;\n  overflow: auto;\n  height: 95%;\n}\n.car-helpPanel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 31vw;\n  padding: 1.5%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.2),\n    0 6px 20px rgba(0, 0, 0, 0.19);\n  z-index: 2;\n}\n.car-helpCard {\n  position: relative;\n  direction: ltr;\n  padding: 1vw;\n  margin: 1.25vw;\n  width: auto;\n  border: solid 1px #1a6a7c;\n  border-radius: 10px;\n  background: #ffffff;\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  font-size: 1.5vw;\n}\n.car-cardCaption {\n  font-family: \"Amatic SC\";\n  font-size: 2vw;\n}\n.car-auxButtonshelp {\n  display: grid;\n  width: 50%;\n  grid-template-columns: repeat(3, auto);\n  gap: 0.5vw;\n  justify-self: center;\n}\n::-webkit-scrollbar-thumb {\n  background-image: linear-gradient(90deg, #cecece, #cecece);\n}\n\n::-webkit-scrollbar {\n  width: 0.5vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
